class MobileNav {
    constructor(navButtonId, mobileNavId) {
        this.mobileNav = document.getElementById(mobileNavId);
        this.navButton = document.getElementById(navButtonId);

        if (this.navButton && this.mobileNav) {
            this.init();
        }
    }

    init() {
        this.navButton.addEventListener("click", () => this.menuToggle());
        document.addEventListener("click", (event) => this.closeMenu(event));
    }

    menuToggle() {
        this.mobileNav.classList.toggle("open");
        this.navButton.classList.toggle('fa-bars');
        this.navButton.classList.toggle('fa-xmark');
    }

    closeMenu() {
        if (!this.mobileNav.contains(event.target) && !this.navButton.contains(event.target)) {
            this.mobileNav.classList.remove("open");
            this.navButton.classList.add('fa-bars');
            this.navButton.classList.remove('fa-xmark');
        }
    }
}
export default MobileNav;